import AppRoute from "models/AppRoute"

const AppSettingsRoute = new AppRoute({
    route: "/app-settings",
    navbar: true,
    authRequired: true,
})

export default AppSettingsRoute
